import { Expose, plainToInstance, Type } from 'class-transformer';

import { CompanyDocumentModel } from '@/entities/company/model/CompanyDocumentModel';
import type { Company } from '@/shared/api/service';

export class CompanyModel {
  @Expose()
  id: number;

  @Expose({ name: 'is_active' })
  isActive?: boolean;

  @Expose()
  name: string;

  @Expose()
  description?: string;

  @Expose()
  contacts?: string;

  @Expose()
  @Type(() => CompanyDocumentModel)
  documents?: CompanyDocumentModel[];
}

export const plainToInstanceCompany = (plain: Company): CompanyModel =>
  plainToInstance(CompanyModel, plain, { excludeExtraneousValues: true });
